import { createSlice } from "@reduxjs/toolkit";
import { setProp } from "Store/Actions";
import { setPropT } from "Store/Actions/ts";
import setObj from "lodash/set";

const initialData = {
  products: [],
  isProductsLoading: false,
  supplier_account_id: [],
  orders: [],
  orderItems: [],
  orderLocation: [],
  merchantDashboard: {
    graph: [],
    analytics: {"id": "weekly","value": "Last Week", "name":"Last Week"},
    todate: "",
    fromDate: "",
    orderList: [],
    orders: {
      ordersData:[],
      orderItemData: [],
      productDataList: []
    },
    quotations:{
      quotationProductList: []
    }
  },
  merchantList: [],
  selectedMerchant: "",
  selectedMerchantAccount: "",
  selectedSalesOrderID: [],
  SelectedSalesOrderItemPrice: [],
  showProductEditDialog: false,
  merchantOrderList:[],
  product_specifications:{
    product_id:"",
    revision_id:"",
    reason_for_rejection:"",
    product_description_id:"",
    price_amount_eur:"",
    supplier_text:"",
    supplier_id:"",
    link: "",
    advantages: "",
    description: "",
    technical_details:"",
    image_base_url:"",
    details_updated_by:"",
    revision_created_by:"",
    deleted_images:[],
    uploaded_images:[],
    thumbnail_image:"",
    new_deleted_images:[],
    nokia_user_deleted_images:[],
    product_images:{
      existing_images:[],
      new_images:[],
      remainingSlots: 4,
      loadApiImages: true
    },
  },
  validationErrors: {},
  isMerchantOrderListLoading: false,
  showEditOrderrDialog: false,
  productDataCount: {},
  showRejectionDialog:false,
  showRejectionDetailsDialog:false,
  productDataCountLoading: false,
  productListCurrentTab:"",
  productRejectComments: "",
  isStockInventoryLoading: false,
  stockInventoryList: [],
  currencySelected: "EUR",
  isOfferItemLoading: false,
  overlayPanelWidth: 0,
  stockInventoryFilters:{
    startDate: "",
    endDate:"",
    filterInventoryOnDates: false,
    duration:{"id": "current_month","value": "Current Month"}
  },
  productGroupedLifeCycleStatus: {}
};

const merchanteSlice = createSlice({
  name: 'merchant',
  initialState: initialData,
  reducers: {
    setProducts(state, action) {
      const data = action.payload
      state.products = data
    },
    setLoader(state, action) {
      const { key, value } = action.payload;
      state[key] = value;
    },
    setSupplierAcccountId(state, action) {
      state.supplier_account_id = action.payload
    },
    setOrders(state, action) {
      const data = action.payload
      state.orders = data
    },
    setOrderItems(state, action) {
      const data = action.payload
      state.orderItems = data
    },
    setDashboard: (state, action) => {
      const { field, value } = action.payload;
      state.merchantDashboard[field] = value;
    },
    setDashboardData(state, action) {
      const {field, filterName, value} = action.payload;
      state.merchantDashboard[field][filterName] = value;
    },
    setMerchantList(state, action) {
      const data = action.payload
      state.merchantList = data
    },
    setSelectMerchant(state, action) {
      const data = action.payload
      state.selectedMerchant = data
    },
    setSelectMerchantAccount(state, action) {
      const data = action.payload
      state.selectedMerchantAccount = data
    },
    setSelectedSalesOrderID(state, action) {
      const data = action.payload
      state.selectedSalesOrderID = data
    },
    setSelectedSalesOrderItemPrice(state, action) {
      const data = action.payload
      state.SelectedSalesOrderItemPrice = data
    },
    setProductSpecificationsField(state, action) {
      const { key, value } = action.payload;
      state.product_specifications[key] = value;
    },
    resetProductSpecifications(state) {
      state.product_specifications = initialData.product_specifications;
    },
    setValidationError(state, action) {
      const { field, error } = action.payload;
      state.validationErrors[field] = error;
    },
    clearValidationError(state, action) {
      delete state.validationErrors[action.payload.field];
    },
    resetValidationErrors(state) {
      state.validationErrors = {};
    },
    setMerchantOrderList(state, action) {
      const data = action.payload
      state.merchantOrderList = data
    },
    setExistingImages(state, action) {
      state.product_specifications.product_images.existing_images = action.payload;
    },
    addNewImages(state, action) {
      state.product_specifications.product_images.new_images.push(...action.payload);
    },
    clearNewImages(state) {
      state.product_specifications.product_images.new_images = [];
    },
    setNewImages(state, action) {
      state.product_specifications.product_images.new_images = action.payload;
    },
    

  },
  extraReducers(builder) {
              builder.addCase(setProp, (state, action: setPropT) => {
                  if (action.payload.slice === merchanteSlice.name) {
                      setObj(state, action.payload.key, action.payload.value);
                  }
              })
          }



})

export default merchanteSlice.reducer;             //setProductSubTypes
export const { setProducts, setLoader, setSupplierAcccountId, setOrders, setExistingImages, addNewImages, clearNewImages,setOrderItems, resetProductSpecifications,setProductSpecificationsField,setDashboard,setDashboardData,setMerchantList,
  setSelectMerchant,setSelectedSalesOrderID,setSelectMerchantAccount, setNewImages,resetValidationErrors, setValidationError, setMerchantOrderList,clearValidationError,setSelectedSalesOrderItemPrice } = merchanteSlice.actions;
